"use strict";

import jQuery from 'jquery';

/**
 * Control zur Anzeige des Lade-Delays bevor die Karte aktualisiert wird.
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCMapLoadingTimer = function( options )
{
	gc.gis.widget.GCWidget.call( this, options );

	var self = this;

	this._target = this.target;	// FIXME: redundant/achtung in abstract-map-control.js
	this._map = options.map;
	this._refresh_rate = 20;
	this._render();

	this._map.on( gc.gis.map.GCMapEvent.LAYER_TREE_UPDATE_SCHEDULED, this, function(evt ) {
		self.update( evt.timeout );
	});
	this._map.on( gc.gis.map.GCMapEvent.LAYER_TREE_UPDATE_CANCELLED, this, function(evt ) {
		if( evt.forced === true )
		{
			clearTimeout( self._timer_timeout );
			clearInterval( self._timer_interval );
			self._timer_timeout = undefined;
			self._timer_interval = undefined;
			self.hide();
		}
	});
};
gc.gis.control.GCMapLoadingTimer.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCMapLoadingTimer.prototype.init = function()
{
	this._render();
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCMapLoadingTimer.prototype._render = function()
{
	if( !this._element )
	{
		if( jQuery(this.target).length === 0 )
		{
			gc.gis.iface.getElement().append( jQuery('<div>', {
				id: this.target.replace(/^#/,'')
			}) );
		}

		this.__element_label = jQuery('<span>', {
			text: 'Karte wird in '+ (this._map.getLoadingTimeout()/1000).toFixed(2) +'s aktualisiert... '
		});
		this.__element_bar = jQuery('<div>', {html: this.__element_label});
		this._element = jQuery('<div>', {
			'class': 'gc-map-control-loading-timer'
		});
		this._element.append( this.__element_bar );

		this._element.hide();
	}
	return this._element;
};

/**
 * Gibt das Container-Element des Controls zurück.
 *
 * @public
 * @return {jQuery} jQuery-Container-Element
 */
gc.gis.control.GCMapLoadingTimer.prototype.getElement = function()
{
	return this._element;
};

/**
 * Zeigt das Control an.
 *
 * @public
 */
gc.gis.control.GCMapLoadingTimer.prototype.show = function()
{
	this.getElement().show('fade');
};

/**
 * Versteckt das Control
 *
 * @public
 */
gc.gis.control.GCMapLoadingTimer.prototype.hide = function()
{
	this.getElement().hide('fade');
};

/**
 * Aktualisiert den Delay-Balken
 *
 * @public
 * @param {number} timeout Delay in Millisekunden
 */
gc.gis.control.GCMapLoadingTimer.prototype.update = function( timeout )
{
	var self = this;

	if( !this._element.is(':visible') )
	{
		this.show();
	}

	if( this._timer_timeout )
	{
		clearTimeout( this._timer_timeout );
	}

	this._percentage = 100;
	this._count = 0;

	if( !this._timer_interval )
	{
		this._timer_interval = setInterval( function() {
			self._percentage = 100-((self._refresh_rate*self._count)/timeout)*100;
			self._count++;
			self.__element_bar.css('width', self._percentage +'%');
		}, this._refresh_rate );
	}

	this._timer_timeout = setTimeout( function() {
		clearInterval( self._timer_interval );
		self._timer_interval = undefined;
		self.hide();
	}, timeout );
};

